if (!customElements.get('nd-product-rail')) {
  customElements.define(
    'nd-product-rail',
    class NDProductRail extends HTMLElement {
      constructor() {
        super();
        this.track = this.querySelector('[data-product-rail-track]');
        this.controls = this.querySelector('.nd-product-rail__controls');
        this.previousButton = this.querySelector('[data-product-rail-previous]');
        this.nextButton = this.querySelector('[data-product-rail-next]');
        this.pointerId = null;
        this.pointerStartX = 0;
        this.pointerStartY = 0;
        this.pointerStartScrollLeft = 0;
        this.pointerDragging = false;
        this.suppressNextClick = false;
        if (!this.track) return;

        this.previousButton?.addEventListener('click', () => this.scroll(-1));
        this.nextButton?.addEventListener('click', () => this.scroll(1));
        this.track.addEventListener('pointerdown', (event) => this.onPointerDown(event));
        this.track.addEventListener('pointermove', (event) => this.onPointerMove(event));
        this.track.addEventListener('pointerup', (event) => this.onPointerEnd(event));
        this.track.addEventListener('pointercancel', (event) => this.onPointerEnd(event));
        this.track.addEventListener('dragstart', (event) => event.preventDefault());
        this.track.addEventListener('click', (event) => {
          if (!this.suppressNextClick) return;
          event.preventDefault();
          event.stopPropagation();
          this.suppressNextClick = false;
        }, true);
        this.resizeObserver = new ResizeObserver(() => this.updateDraggable());
        this.resizeObserver.observe(this.track);
        window.requestAnimationFrame(() => this.updateDraggable());
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      scroll(direction) {
        const firstCard = this.track.firstElementChild;
        if (!firstCard) return;
        const styles = window.getComputedStyle(this.track);
        const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
        this.track.scrollBy({ left: direction * (firstCard.getBoundingClientRect().width + gap), behavior: 'smooth' });
      }

      updateDraggable() {
        const isDraggable = this.track.scrollWidth > this.track.clientWidth + 1;
        this.track.classList.toggle('nd-product-rail__track--draggable', isDraggable);
        this.controls?.toggleAttribute('hidden', !isDraggable);
      }

      onPointerDown(event) {
        if (
          event.pointerType === 'touch' ||
          !event.isPrimary ||
          (event.pointerType === 'mouse' && event.button !== 0) ||
          this.track.scrollWidth <= this.track.clientWidth + 1
        ) return;
        this.pointerId = event.pointerId;
        this.pointerStartX = event.clientX;
        this.pointerStartY = event.clientY;
        this.pointerStartScrollLeft = this.track.scrollLeft;
        this.pointerDragging = false;
      }

      onPointerMove(event) {
        if (event.pointerId !== this.pointerId) return;
        const distanceX = event.clientX - this.pointerStartX;
        const distanceY = event.clientY - this.pointerStartY;
        if (!this.pointerDragging) {
          if (Math.abs(distanceX) < 8 || Math.abs(distanceX) <= Math.abs(distanceY)) return;
          this.pointerDragging = true;
          this.track.classList.add('is-dragging');
          try {
            this.track.setPointerCapture?.(event.pointerId);
          } catch (_error) {
            // Older Safari versions can expose Pointer Capture but reject it.
          }
        }
        if (event.cancelable) event.preventDefault();
        this.track.scrollLeft = this.pointerStartScrollLeft - distanceX;
      }

      onPointerEnd(event) {
        if (event.pointerId !== this.pointerId) return;
        const didDrag = this.pointerDragging;
        if (this.track.hasPointerCapture?.(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
        this.pointerId = null;
        this.pointerDragging = false;
        this.track.classList.remove('is-dragging');
        this.suppressNextClick = event.type === 'pointerup' && didDrag;
        if (this.suppressNextClick) window.setTimeout(() => { this.suppressNextClick = false; }, 250);
      }
    }
  );
}
